import styles from './utils/SupportComponent.module.scss';
import React, {useEffect, useState} from "react";
import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";
import SupportComponent from "@/admin/pages/support/utils/SupportComponent";
import {useLocation, useNavigate} from "react-router-dom";
import ApiInterface from "@/commons/api/ApiInterface";
import CustomButton from "@/commons/components/buttons/customButton/CustomButton";

const DirectoryIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 16 16">
        <path fill="#327c7c"
              d="M1.75 1A1.75 1.75 0 0 0 0 2.75v10.5C0 14.216.784 15 1.75 15h12.5A1.75 1.75 0 0 0 16 13.25v-8.5A1.75 1.75 0 0 0 14.25 3H7.5a.25.25 0 0 1-.2-.1l-.9-1.2C6.07 1.26 5.55 1 5 1H1.75Z"/>
    </svg>
);

const supportPages = [
    {
        path: "moderations/punishments",
        fileName: "Punizioni.md",
        requiredPermission: "adminpages.support.moderations",
        name: "Lista Moderazioni"
    },
    {
        path: "moderations/files/ledger",
        fileName: "Ledger.md",
        requiredPermission: "adminpages.support.moderations",
        name: "Aiuti Ledger"
    },
    {
        path: "moderations/files/CoreProtect",
        fileName: "CoreProtect.md",
        requiredPermission: "adminpages.support.moderations",
        name: "Aiuti CoreProtect"
    }
];

const Support = () => {
    const location = useLocation();
    const file = location.pathname.replace("/support/", "");
    const navigate = useNavigate();
    const [permissionsMap, setPermissionsMap] = useState<{ [key: string]: boolean }>({});

    useEffect(() => {
        if (file === "/support") {
            navigate("/support/" + supportPages[0].path);
        }
        loadUserPermissions();
    }, [file]);

    const loadUserPermissions = async () => {
        const results = await Promise.all(
            supportPages.map(p =>
                ApiInterface.hasPermission(p.requiredPermission)
                    .then(result => ({ [p.requiredPermission]: result === true }))
            )
        );
        const permissions = Object.assign({}, ...results);
        setPermissionsMap(permissions);
    };

    const matchedPage = supportPages.find(p => p.path === file);
    const hasPermission = matchedPage ? permissionsMap[matchedPage.requiredPermission] : false;

    return (
        <>
            <Header/>
            <div className={styles.content}>
                <div className={`${styles.subCategory} ${styles.filesManagement}`}>
                    <DirectoryIcon/>
                    <div className={styles.categoryContent}>
                        {homeButton("Torna alla Home Admin", `/`, navigate, false)}
                        <h2>File di Supporto</h2>
                        <div className={styles.buttonGroup}>
                            {supportPages.map((page) =>
                                permissionsMap[page.requiredPermission]
                                    ? homeButton(page.name, `/support/${page.path}`, navigate, file === page.path)
                                    : disabledHomeButton(page.name)
                            )}
                        </div>
                    </div>
                </div>
                <br/>
                {matchedPage && hasPermission && (
                    <SupportComponent
                        fileName={matchedPage.fileName}
                        requiredPermission={matchedPage.requiredPermission}
                    />
                )}
            </div>
            <Footer/>
        </>
    );
};

export default Support;

const homeButton = (
    text: string,
    link: string,
    navigate: ReturnType<typeof useNavigate>,
    isActive: boolean
) => (
    <CustomButton className={`${isActive ? styles.active : styles.inactive}`} onClick={() => navigate(link)}>
        {text}
    </CustomButton>
);

const disabledHomeButton = (
    text: string
) => (
    <CustomButton disabled className={styles.disabled}>
        {text}
    </CustomButton>
);